import { render, staticRenderFns } from "./WaypointSortingDialog.vue?vue&type=template&id=16d9ecb8"
import script from "./WaypointSortingDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./WaypointSortingDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports